var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 11.5,
    fill: "#C30000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0534 10.2779C20.639 9.69875 20.6562 8.73223 20.0918 8.11911C19.5274 7.50599 18.5952 7.47844 18.0096 8.05759L14.407 11.6207L10.8044 8.05759C10.2188 7.47844 9.28663 7.50599 8.72224 8.11911C8.15785 8.73223 8.17502 9.69875 8.76058 10.2779L12.2626 13.7415L8.75534 17.2104C8.16978 17.7895 8.15261 18.7561 8.717 19.3692C9.28139 19.9823 10.2136 20.0098 10.7992 19.4307L14.407 15.8624L18.0148 19.4307C18.6004 20.0098 19.5326 19.9823 20.097 19.3692C20.6614 18.7561 20.6442 17.7895 20.0587 17.2104L16.5514 13.7415L20.0534 10.2779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/Cross Circle.5daca878c81b2830693f9b73fdd04dcb.svg";
export { ForwardRef as ReactComponent };